import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const POINTS = [
    <>
        <strong>20+ years</strong> experienced in Software Implementation,
        Testing, Engineering and IT business analysis across Australia &amp;
        NZ
    </>,
    <>
        Personalised attention with robust digital platforms. We combine
        strategic oversight with hands-on execution across web and mobile
        applications to deliver the right outcome for your business.
    </>,
    <>Our teams are motivated by outcomes, not just outputs.</>,
    <>
        We assess current technology, define the right products and
        platforms, and map a roadmap built around measurable business
        outcomes.
    </>,
    <>
        All professionals working with us hold Australian Government{" "}
        <strong>Baseline security clearance</strong>, with several also
        cleared to <strong>NV1</strong> — so engagements in government and
        other sensitive environments are handled from day one.
    </>,
    <>
        Build-Operate-Transfer engagements that scale as your business needs
        change.
    </>,
];

export default function About() {
    const [photoSrc, setPhotoSrc] = useState("/team.png");

    useEffect(() => {
        let cancelled = false;
        fetch(`${API}/settings/public`)
            .then((r) => r.json())
            .then((d) => {
                if (!cancelled && d.about_photo_file_id) {
                    setPhotoSrc(`${API}/media/${d.about_photo_file_id}`);
                }
            })
            .catch(() => {});
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <section id="about">
            <div className="wrap">
                <div className="about-grid">
                    <motion.div
                        className="about-photo-wrap"
                        initial={{ opacity: 0, y: 28 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.25 }}
                        transition={{ duration: 0.9, ease: EASE }}
                    >
                        <img
                            src={photoSrc}
                            alt="The SoftwareFairGo team reviewing a project together"
                            className="about-photo"
                            data-testid="about-founder-photo"
                            loading="lazy"
                        />
                        <div className="about-photo-badge">
                            INDEPENDENT ADVISORY — AUSTRALIA &amp; NZ
                        </div>
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, y: 28 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.25 }}
                        transition={{
                            duration: 0.9,
                            ease: EASE,
                            delay: 0.12,
                        }}
                    >
                        <p className="about-quote">
                            "Vendors are answering to their sales targets. We
                            only answer to you."
                        </p>
                        <ul className="about-points" data-testid="about-points">
                            {POINTS.map((point, i) => (
                                <li key={i}>{point}</li>
                            ))}
                        </ul>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
